import { Badge } from "@/components/ui/Badge";
import { ORDER_TYPE_LABELS, type OrderType } from "../types";

/** Typ zamówienia przy numerze. Na listach `hideStandard` — zwykłe zamówienia to
 *  zdecydowana większość, więc znaczek niesie informację tylko przy typach szczególnych. */
export function OrderTypeBadge({
  type,
  display,
  hideStandard = false,
  className,
}: {
  type: OrderType;
  display?: string;
  hideStandard?: boolean;
  className?: string;
}) {
  if (hideStandard && type === "standard") return null;
  return (
    <Badge
      color={type === "standard" ? "gray" : "purple"}
      title={display ? `Typ zamówienia: ${display}` : undefined}
      className={className}
    >
      {ORDER_TYPE_LABELS[type] ?? display ?? type}
    </Badge>
  );
}
